import { Gravatar } from "../../../../src/utils/gravatar";

/**
 * Truterritory layers
 */

angular.module("routes:mapping").directive("truterritoryLayers", function () {
  return {
    scope: {
      map: "=",
      workspace: "=",
      workspaces: "=",
      setWorkspace: "=",
      saveNewWorkspace: "&",
      deleteMap: "=",
    },
    templateUrl: "/truterritory/layers.html",
    controller: function ($scope, Collection, Workspace, Session, $uibModal, filterFilter, MappingModals, hasMapAccess) {
      let allCollections = [];
      getAllCollections();
      setupWorkspaceOwners();

      $scope.search = null;
      $scope.limitToWorkspace = false;
      $scope.collections = [];
      $scope.openWorkspaceModal = MappingModals.openSaveWorkspace;
      $scope.hasAccess = hasMapAccess;

      let sharedDroppable = {
        appendTo: "body",
        cancel: ".disabled",
        zIndex: 5000,
        helper: function (event, element) {
          return $(element)
            .clone()
            .css({ width: $(element).width(), height: $(element).css("height") });
        },
        update: function (event, ui) {
          ui.item.sortable.dropindex = ui.item.sortable.index;
        },
      };

      $scope.collectionDroppable = angular.copy(sharedDroppable);
      $scope.mapDroppable = angular.copy(sharedDroppable);
      $scope.collectionDroppable.connectWith = ".map-holder";
      $scope.mapDroppable.connectWith = [".map-holder", ".bookmarks-drop"];

      /**
       * Check whether collection is used in the current map
       * @param  {int}  collectionID
       * @return {Boolean}
       */
      $scope.isCollectionActive = function (collectionID) {
        return _.findIndex($scope.map.collections, { ID: collectionID }) != -1;
      };

      /**
       * Remove a collection from the current workspace
       * @param  {int} collectionID
       * @return {void}
       */
      $scope.removeCollection = function (collectionID) {
        $scope.workspace.removeCollection(collectionID).then(function () {
          // Re-run search filters
          $scope.filterCollections($scope.search, $scope.limitToWorkspace);
        });
      };

      /**
       * Create a new workspace
       * @param  {Object} workspace
       * @return {Promise}
       */
      $scope.createWorkspace = function (workspace) {
        let userID = Session.get("ID");
        workspace = { name: workspace.name, userID: userID, userIDs: [userID] };
        return Workspace.post(workspace, { with: "all" }).then(function (response) {
          $scope.workspaces.push(response);
          return $scope.selectWorkspace(response, false);
        });
      };

      /**
       * Remove the logged-in user from the given workspace
       * @param  {Object} workspace
       * @return {Promise}
       */
      $scope.removeWorkspace = function (workspace) {
        let userID = Session.get("ID");

        let modal = $uibModal.open({
          templateUrl: "/truterritory/confirm-remove-user-workspace.html",
        });

        return modal.result
          .then(function () {
            return workspace.removeUser(userID);
          })
          .then(function () {
            _.remove($scope.workspaces, { ID: workspace.ID });
            if (workspace.ID == $scope.workspace.ID) $scope.setWorkspace(_.find($scope.workspaces, { default: 1 }));
          });
      };

      /**
       * Update the name or sharing options of the workspace
       */
      $scope.updateWorkspace = function () {
        $scope.workspace.patch(_.pick($scope.workspace, ["name", "sharingEnabled"]));
      };

      /**
       * Start using the given workspace
       * @param  {Object}  workspace
       * @param  {Boolean} fetch
       * @return {void}
       */
      $scope.selectWorkspace = function (workspace, fetch = true) {
        $scope.setWorkspace(workspace, fetch).then(function () {
          $scope.resetFilters();
          $scope.filterCollections($scope.search, $scope.limitToWorkspace);
        });
      };

      /**
       * Clear the collection search filters
       * @return {void}
       */
      $scope.resetFilters = function () {
        $scope.search = null;
        $scope.limitToWorkspace = false;
      };

      /**
       * Filters the collections
       * @param  {string} val
       * @param  {boolean} limitToWorkspace
       * @return {void}
       */
      $scope.filterCollections = function (val, limitToWorkspace) {
        // get the list of collections, either limited by workspace, or not
        var collections = limitToWorkspace ? angular.copy($scope.workspace.collections) : allCollections.clone();
        collections = _.filter(collections, function (c) {
          return !!c.geometryType;
        });

        // If there's not a search string, set the whole array
        //  Else, search
        if (!val) $scope.collections = collections;
        else $scope.collections = filterFilter(collections, { name: val });
      };

      /**
       * Set owner information on each workspace to differentiate between owned and shared
       * @return {void}
       */
      function setupWorkspaceOwners() {
        for (let i = 0; i < $scope.workspaces.length; i++) {
          let workspace = $scope.workspaces[i];

          if (workspace.userID != Session.get("ID") && !workspace.nameAppended) {
            let user = _.find(workspace.users, { ID: workspace.userID });
            if (user) {
              workspace.image = Gravatar(user.emailSum, 20);
              workspace.name += " (" + user.fname + " " + user.lname + "'s)";
              workspace.nameAppended = true;
            }
          }
        }
      }
    },
  };
});
